import { IReportService } from "../../service/report/ReportService";

export default class GetDataReport8Interactor {
  private reportService: IReportService;

  constructor(reportService) {
    this.reportService = reportService;
  }

  async execute(reportingPeriodId: number, applicantIdsList: number[]) {
    return this.reportService.getDataReport8(
      reportingPeriodId,
      applicantIdsList
    );
  }
}
